import { ActionTypes } from "../type";

const initialState ={
    roles:null
}

export const rolesReducer = (state=initialState,action)=>{
    switch (action.type){
        case ActionTypes.ROLESLIST:
            return {...state,roles:action.payload}
        default:
            return state;
    }
}